/** Shared tactile response for buttons and selectable cards. */
export const pressFeedback = {
  transition:
    'transform {durations.moderate} {easings.ease-out}, background-color {durations.moderate} {easings.ease-out}, border-color {durations.moderate} {easings.ease-out}, color {durations.moderate} {easings.ease-out}',
  _active: { transform: 'scale(0.97)' },
  _disabled: { _active: { transform: 'none' } },
  _motionReduce: {
    transition: 'none',
    transform: 'none',
    _active: { transform: 'none' },
  },
} as const;
